import { ClaraCard } from "~/application/types/entities/ClaraCard.type";
import { ClaraCardDTO } from "../dtos/ClaraCardDTO";

export const mapClaraCardDTO = (data: ClaraCardDTO): ClaraCard => {
  return {
    uuid: data.uuid,
    description: data.description,
    number: data.number,
    alias: data.alias,
    periodicity: data.periodicity,
    type: data.type,
    status: data.status,
    lockCode: data.lock_code,
    threshold: data.threshold,
    maskedPan: data.masked_pan,
    expiryDate: data.expiry_date,
    userFullName: data.user_full_name,
    userId: data.user_uuid,
    cvv: data.cvv,
  };
};
